export default __webpack_public_path__ + "static/media/telegram-icon.9f1b130f.svg";